import { translate } from '@vimeo/i18n-runtime';

import styles from './PasswordForm.module.scss';

const PasswordForm = ({ handleChange, handleSubmit, invalidPassword, password }) => {
  const wrongPassword = 'Sorry, that’s not the password';
  const inputElementClassName = `${styles.passwordInput} ${invalidPassword ? styles.invalid : ''}`;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit(e);
      }}
    >
      <div className={styles.passwordContainer}>
        <div className={styles.passwordInputContainer}>
          <input
            type="password"
            className={inputElementClassName}
            name="password"
            placeholder={translate('Enter Password')}
            aria-invalid="true"
            format="negative"
            value={password}
            onChange={(e) => handleChange(e)}
          />
          {invalidPassword && (
            <div className={styles.passwordErrorIconContainer} format="negative">
              <svg viewBox="0 0 24 24">
                <path
                  fill="#ff4d4d"
                  d="M11 7h2v6h-2zM12 17a1 1 0 0 1-.38-.08 1.15 1.15 0 0 1-.33-.21 1 1 0 0 1-.21-1.09 1 1 0 0 1 .21-.33A1 1 0 0 1 13 16a1 1 0 0 1-1 1z"
                />
                <path
                  d="M12 22a10 10 0 1 1 10-10 10 10 0 0 1-10 10zm0-18a8 8 0 1 0 8 8 8 8 0 0 0-8-8z"
                  fill="#ff4d4d"
                />
              </svg>
            </div>
          )}
          {invalidPassword && <p className={styles.errorStateInvalidPassword}>{wrongPassword}</p>}
        </div>
        <button className={styles.passwordSubmit}>Submit</button>
      </div>
    </form>
  );
};

export default PasswordForm;
